import { render, staticRenderFns } from "./MigrateTab.vue?vue&type=template&id=f92e3d20&scoped=true"
import script from "./MigrateTab.vue?vue&type=script&lang=js"
export * from "./MigrateTab.vue?vue&type=script&lang=js"
import style0 from "./MigrateTab.vue?vue&type=style&index=0&id=f92e3d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92e3d20",
  null
  
)

export default component.exports